import { makeAutoObservable } from "mobx";

class CookieStore {
  consentGiven = false;
  showConsent = false;

  constructor() {
    makeAutoObservable(this);
    const stored = localStorage.getItem("cookieConsent");

    if (stored === "true") {
      this.consentGiven = true;
    } else if (stored === "dismissed") {
      this.consentGiven = false;
      this.showConsent = false;
    } else {
      this.scheduleConsentPopup();
    }
  }

  giveConsent = () => {
    this.consentGiven = true;
    this.showConsent = false;
    localStorage.setItem("cookieConsent", "true");
  };

  hideConsent = () => {
    this.consentGiven = false;
    this.showConsent = false;
    localStorage.setItem("cookieConsent", "dismissed");
  };

  hideCokies = () => {
    this.consentGiven = false;
    this.showConsent = false;
    localStorage.setItem("cookieConsent", "dismissed");
  };

  scheduleConsentPopup = (delay = 3000) => {
    setTimeout(() => {
      if (!this.consentGiven) {
        this.showConsent = true;
      }
    }, delay);
  };
}

const cookieStore = new CookieStore();
export default cookieStore;
